import { render } from "./Pagination.vue?vue&type=template&id=d7e69d7e&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=d7e69d7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d7e69d7e"

export default script